import React, { useEffect } from "react"
import "./_tile-content-investor.scss"

// Utils
import UniversalLink from "§/src/utils/UniversalLink"

// Assets
import PatternDashed from "§/src/images/svg/pattern-dashed.svg"
import Clock from "§/src/images/svg/clock.svg"
import ButtonArrow from "§/src/components/atoms/buttons/button-arrow"

// Language
import { useTranslation } from 'react-i18next'

const InvestorTile = props => {
  const { t } = useTranslation();

  useEffect(() => {
    // get data from Teleborsa api
    fetch(`https://syndication.teleborsa.it/gefran/2022/Data/snapshot.js`)
      .then(response => response.json()) // parse JSON from request
      .then(resultData => {
        var lastPriceEl = document.getElementById("stg-lastprice")
        var percentChangeEl = document.getElementById("stg-variation")
        var timeStampEl = document.getElementById("stg-date")

        lastPriceEl.innerText = resultData.lastPrice

        // red text if negative variation
        // add space after sign
        if (resultData.percentChange < 0) {
          percentChangeEl.classList.add("text-danger")
        }
        var percentChange = resultData.percentChange
          .toString()
          .replace("-", "- ")
        percentChangeEl.innerText = percentChange

        // Make date
        const time = new Date( resultData.timeStamp )
        const locale = process.env.GATSBY_SITE_LANG.replace('_','-')

        const date = time.toLocaleDateString(locale, { year: "numeric", month: "numeric", day: "numeric"})
        const hour = time.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" })

        var dateString = date + " - " + hour
        timeStampEl.innerText = dateString
      }) // set data for the number of stars
  }, [])

  // const { ...atomProps } = props.data;

  // set atom class
  const atomClassName = "investor-card"
  var atomClass =
    props.className !== undefined
      ? atomClassName + " " + props.className
      : atomClassName

  const cta = props?.data?.link
  const linkTitle = props?.data?.title

  return (
    <div id="tile-content-investor" className={atomClass}>
      <div className="card h-100">
        <div className="card-body">
          <span className="card-pretitle fs-9 text-uppercase mb-2">
            {props?.title ? (
              props.title
            ) : (
              <>
                <span className="title-investor-relations">{t("Investor relations")}</span>
                <br />
                <span className="text-gefran">Gefran</span>
              </>
            )}
          </span>
          <div className="card-quotation mb-2">
            <span className="fs-40 ff-van-condensed-pro fw-bold">
              € <span id="stg-lastprice" />
            </span>
            <div className="data ms-3 fs-14">
              <span>{t('Variazione')} %</span>
              <span id="stg-variation" className="" />
            </div>
          </div>
          <div className="date fs-14">
            <Clock />
            <span id="stg-date" className="ms-2" />
          </div>

          {cta && cta[1] && (
            <UniversalLink to={cta} className="mt-auto">
              <ButtonArrow
                dir="end"
                text={cta[2]}
                className="cta mt-auto me-auto stretched-link text-white"
              >
                {linkTitle}
              </ButtonArrow>
            </UniversalLink>
          )}
        </div>
        <div className="bg">
          <PatternDashed />
        </div>
      </div>
    </div>
  )
}

export default InvestorTile
